export default __webpack_public_path__ + "static/media/bell.5628f01c.svg";